import { render } from "./TaskDialog.vue?vue&type=template&id=9257665e"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"

import "./TaskDialog.vue?vue&type=style&index=0&id=9257665e&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__